const patternConstant = {
  ALPHANUMERIC: /^[a-zA-Z0-9- ]+$/,
  NUMERIC: /^[0-9]+$/,
  FLOATNUMERIC: /^\d+(\.\d{0,2})?$/,
  PERCENTAGE: /^(\d{0,2})(\.\d{0,2})?$/,
  PRICE: /^(([0-9]{0,9})|([.{1}]\d{0,2})|(\d+(\.\d{0,2})))?$/,
  THREE_DIGIT_STARTING_NON_ZERO: /^(([1-9]{1,9})|(\d{0,3})|(\d+(\.\d{0})))?$/,
  ///^\d{0,2}+(\.\d{0,2})?$/
};
export const invoiceFormData = {
  invoice_number: null,
  invoice_type: "",
  created_at: "",
  due_date: null,
  customer_id: "",
  invoice_to: "",
  address_id: "",
  items: [
    {
      quantity: null,
      description: "",
      rate: null,
      price: null,
      total: null,
      vat_rate: null,
      vat_value: null,
    },
  ],
  net: null,
  quick_pay: null,
  vat_amount: null,
  is_vat_included: false,
  method: "",
  zero_vat: 0,
  pay_date: null,
  total_amount: null,
  is_values_fixed: false,
  status: "Outstanding",
  outstandingBalance: null,
};
export const DEPOSIT_INVOICE_FORM_ELEMENTS = [
  {
    id: "invoice_number",
    label: "Invoice No.",
    placeHolder: "",
    type: "text",
    editReadOnly: true,
    heightVal: "calc(100% - 24px)",
    // isRequired: true,
    md: 6,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },

  {
    id: "customer_name",
    label: "Invoice To",
    placeHolder: "",
    type: "text",
    heightVal: "calc(100% - 24px)",

    // editReadOnly: true,
    md: 6,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "address",
    label: "Address (Street)",
    placeHolder: "",
    type: "text",
    heightVal: "calc(100% - 24px)",

    // editReadOnly: true,
    md: 12,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "quote_primary_task",
    label: "Primary Task",
    placeHolder: "",
    type: "text",
    heightVal: "calc(100% - 24px)",

    // editReadOnly: true,
    md: 12,
    inputProps: {
      maxLength: 50,
    },
    // patternAllowed: patternConstant?.ALPHANUMERIC,
  },

  {
    id: "quote_amount",
    label: "Quote Amount (£)",
    placeHolder: "",
    type: "text",
    // isRequired: true,
    // editReadOnly: true,
    md: 4,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.PRICE,
  },
  {
    id: "total_amount",
    label: "Deposit Amount (£)",
    placeHolder: "",
    type: "text",
    isRequired: true,
    // editReadOnly: true,
    md: 4,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.PRICE,
  },
  {
    id: "due_date",
    label: "Invoice Due Date",
    placeHolder: "",
    type: "date",
    heightVal: "calc(100% - 28px)",
    isRequired: true,
    // editReadOnly: true,
    md: 4,
  },
  {
    id: "method",
    label: "Method",
    placeHolder: "",
    type: "select",
    options: [
      "Debit Card",
      "Credit Card",
      "Cash",
      "Bank Transfer",
      "Direct Debit",
      "Standing Order",
      "Cheque",
      "Contract",
      "Viva Wallet",
      "Other",
    ],
    isRequired: true,
    md: 4,
  },
  {
    id: "status",
    label: "\u00A0",
    checkLabel: "Auto Pay",
    placeHolder: "",
    type: "checkbox",
    md: 4,
  },
];

export const invoiceFormElements = [
  {
    id: "invoice_number",
    label: "Invoice No.",
    placeHolder: "",
    type: "text",
    editReadOnly: true,
    heightVal: "calc(100% - 24px)",
    // isRequired: true,
    md: 3,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  // {
  //   id: "",
  //   label: "",
  //   type: "title",
  //   md: 9,
  // },

  {
    id: "invoice_type",
    label: "Invoice Type",
    placeHolder: "",
    type: "text",
    // heightVal: "calc(100% - 24px)",
    // options: [],
    isRequired: true,
    editReadOnly: true,
    md: 3,
  },
  // {
  //   id: "",
  //   label: "",
  //   type: "title",
  //   md: 8,
  // },
  {
    id: "created_at",
    label: "Invoice Date",
    placeHolder: "",
    type: "date",
    heightVal: "calc(100% - 28px)",
    isRequired: true,
    // editReadOnly: true,
    md: 3,
  },
  // {
  //   id: "",
  //   label: "",
  //   type: "title",
  //   md: 1,
  // },
  {
    id: "due_date",
    label: "Due Date",
    placeHolder: "",
    type: "date",
    isRequired: true,
    md: 3,
  },
  // {
  //   id: "",
  //   label: "",
  //   type: "title",
  //   md: 3,
  // },
  {
    id: "customer_name",
    label: "Invoice To",
    placeHolder: "",
    type: "text",
    heightVal: "calc(100% - 24px)",
    isRequired: true,
    editReadOnly: true,
    md: 3,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  // {
  //   id: "",
  //   label: "",
  //   type: "title",
  //   md: 8,
  // },
  {
    id: "address",
    label: "Address",
    placeHolder: "",
    type: "text1",
    heightVal: "calc(100% - 24px)",
    isRequired: true,
    editReadOnly: true,
    md: 9,
    inputProps: {
      maxLength: 100,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "description",
    label: "Invoice Details",
    placeHolder: "",
    type: "text",
    heightVal: "calc(100% - 24px)",
    // isRequired: true,
    // editReadOnly: true,
    md: 12,
    inputProps: {
      maxLength: 100,
    },
    // patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  // {
  //   id: "",
  //   label: "",
  //   type: "title",
  //   md: 8,
  // },
];

export const INVOICE_TYPES_OPTIONS = [
  {
    id: "removal",
    name: "Removal",
  },
  {
    id: "storage",
    name: "Storage",
  },
  {
    id: "international",
    name: "International",
  },
  {
    id: "shipping",
    name: "Shipping",
  },
  {
    id: "air freight",
    name: "Air Freight",
  },
  {
    id: "fulfilment",
    name: "Fulfilment",
  },
  {
    id: "other",
    name: "Other",
  },
];

export const CREATE_INVOICE_FORM_ELEMENTS = [
  {
    id: "invoice_number",
    label: "Invoice No.",
    placeHolder: "",
    type: "text",
    editReadOnly: true,
    heightVal: "calc(100% - 24px)",
    // isRequired: true,
    md: 3,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  // {
  //   id: "",
  //   label: "",
  //   type: "title",
  //   md: 9,
  // },

  {
    id: "invoice_type",
    label: "Invoice Type",
    placeHolder: "",
    type: "select",
    // heightVal: "calc(100% - 24px)",
    options: [],
    isRequired: true,
    // editReadOnly: true,
    md: 3,
  },
  // {
  //   id: "",
  //   label: "",
  //   type: "title",
  //   md: 8,
  // },
  {
    id: "created_at",
    label: "Invoice Date",
    placeHolder: "",
    type: "date",
    heightVal: "calc(100% - 28px)",
    isRequired: true,
    // editReadOnly: true,
    md: 3,
  },
  // {
  //   id: "",
  //   label: "",
  //   type: "title",
  //   md: 0.5,
  // },
  {
    id: "due_date",
    label: "Due Date",
    placeHolder: "",
    type: "date",
    isRequired: true,
    disablePast: true,
    md: 3,
  },
  // {
  //   id: "",
  //   label: "",
  //   type: "title",
  //   md: 3,
  // },
  {
    id: "customer_email",
    label: "Email",
    placeHolder: "",
    type: "text",
    heightVal: "calc(100% - 24px)",
    isRequired: true,
    editReadOnly: true,
    md: 3,
    inputProps: {
      maxLength: 50,
    },
    // patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "customer_name",
    label: "Invoice To",
    placeHolder: "",
    type: "text",
    heightVal: "calc(100% - 24px)",
    isRequired: true,
    editReadOnly: true,
    md: 3,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  // {
  //   id: "",
  //   label: "",
  //   type: "title",
  //   md: 0.5,
  // },

  {
    id: "address",
    label: "Address (Street)",
    placeHolder: "",
    type: "text",
    heightVal: "calc(100% - 24px)",
    isRequired: true,
    editReadOnly: true,
    md: 3,
    inputProps: {
      maxLength: 100,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
   {
    id: "description",
    label: "Invoice Details",
    placeHolder: "",
    type: "text",
    heightVal: "calc(100% - 24px)",
    // isRequired: true,
    // editReadOnly: true,
    md: 12,
    inputProps: {
      maxLength: 100,
    },
    // patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  //  {
  //   id: "",
  //   label: "",
  //   type: "title",
  //   md: 0.5,
  // },
  // {
  //   id: "town",
  //   label: "Town",
  //   placeHolder: "",
  //   type: "text",
  //   heightVal: "calc(100% - 24px)",
  //   // isRequired: true,
  //   // editReadOnly: true,
  //   md: 2,
  //   inputProps: {
  //     maxLength: 50,
  //   },
  //   patternAllowed: patternConstant?.ALPHANUMERIC,
  // },
  //  {
  //   id: "postcode",
  //   label: "Post Code",
  //   placeHolder: "",
  //   type: "text",
  //   heightVal: "calc(100% - 24px)",
  //   // isRequired: true,
  //   // editReadOnly: true,
  //   md: 2.5,
  //   inputProps: {
  //     maxLength: 50,
  //   },
  //   patternAllowed: patternConstant?.ALPHANUMERIC,
  // },
  // {
  //   id: "",
  //   label: "",
  //   type: "title",
  //   md: 8,
  // },
];

export const CREATE_CREDIT_INVOICE_FORM_ELEMENTS = [
  {
    id: "invoice_number",
    label: "Credit Note No.",
    placeHolder: "",
    type: "text",
    editReadOnly: true,
    heightVal: "calc(100% - 24px)",
    // isRequired: true,
    md: 3,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  // {
  //   id: "",
  //   label: "",
  //   type: "title",
  //   md: 9,
  // },

  {
    id: "invoice_type",
    label: "Invoice Type",
    placeHolder: "",
    type: "text",
    // heightVal: "calc(100% - 24px)",
    options: [],
    isRequired: true,
    editReadOnly: true,
    md: 3,
  },
  // {
  //   id: "",
  //   label: "",
  //   type: "title",
  //   md: 8,
  // },
  {
    id: "created_at",
    label: "Date",
    placeHolder: "",
    type: "text",
    heightVal: "calc(100% - 28px)",
    isRequired: true,
    editReadOnly: true,
    md: 3,
  },
  // {
  //   id: "",
  //   label: "",
  //   type: "title",
  //   md: 0.5,
  // },
  {
    id: "due_date",
    label: "Due Date",
    placeHolder: "",
    type: "date",
    isRequired: true,
    disablePast: true,
    md: 3,
  },
   {
    id: "customer_email",
    label: "Email",
    placeHolder: "",
    type: "text",
    heightVal: "calc(100% - 24px)",
    isRequired: true,
    editReadOnly: true,
    md: 3,
    inputProps: {
      maxLength: 50,
    },
    // patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "customer_name",
    label: "Credit Note To",
    placeHolder: "",
    type: "text",
    heightVal: "calc(100% - 24px)",
    isRequired: true,
    editReadOnly: true,
    md: 3,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
 {
    id: "reference_invoices",
    label: "Reference Invoice",
    placeHolder: "",
    type: "multiselectcheckbox",
    options:[],
    heightVal: "calc(100% - 24px)",
    // isRequired: true,
    // editReadOnly: true,
    md: 6,

 },
  {
    id: "total_invoice_amount",
    label: "Total Invoice Amount (£)",
    placeHolder: "",
    type: "text",
    heightVal: "calc(100% - 24px)",
    // isRequired: true,
    editReadOnly: true,
    md: 2,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
 {
    id: "reason",
    label: "Reason for Credit",
    placeHolder: "",
    type: "text",
    heightVal: "calc(100% - 24px)",
    // isRequired: true,
    // editReadOnly: true,
    md: 4,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "address",
    label: "Address (Street)",
    placeHolder: "",
    type: "text",
    heightVal: "calc(100% - 24px)",
    isRequired: true,
    editReadOnly: true,
    md: 3,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
 
];

export const invoiceVatFormElements = [
  {
    id: "net",
    label: "Net (£)",
    placeHolder: "",
    type: "text",
    isRequired: true,
    // editReadOnly: true,
    md: 3,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.PRICE,
  },
  {
    id: "",
    label: "",
    type: "title",
    md: 6,
  },
  {
    id: "quick_pay",
    label: "Quick Pay (£)",
    placeHolder: "",
    type: "text",
    // isRequired: true,
    editReadOnly: true,
    md: 2,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },

  {
    id: "vat_amount",
    label: "VAT (£)",
    placeHolder: "",
    type: "text",
    // editReadOnly: true,
    // isRequired: true,
    md: 3,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.PRICE,
  },
  {
    id: "is_vat_included",
    label: "\u00A0",
    checkLabel: "VAT Included",
    placeHolder: "",
    type: "checkbox",
    md: 3,
  },
  {
    id: "",
    label: "",
    type: "title",
    md: 3,
  },
  {
    id: "method",
    label: "Method",
    placeHolder: "",
    type: "select",
    options: [
      "Debit Card",
      "Credit Card",
      "Cash",
      "Bank Transfer",
      "Direct Debit",
      "Standing Order",
      "Cheque",
      "Contract",
      "Viva Wallet",
      "Other",
    ],
    // isRequired: true,
    md: 3,
  },
  {
    id: "zero_vat",
    label: "Zero VAT",
    placeHolder: "",
    type: "text",
    editReadOnly: true,
    md: 3,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },

  {
    id: "",
    label: "",
    type: "title",
    md: 6,
  },
  {
    id: "pay_date",
    label: "Pay Date",
    placeHolder: "",
    type: "date",

    md: 3,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "total_amount",
    label: "Total (£)",
    placeHolder: "",
    type: "text",
    editReadOnly: true,
    // isRequired: true,
    md: 3,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "is_values_fixed",
    label: "\u00A0",
    checkLabel: "Fix Values",
    placeHolder: "",
    type: "checkbox",
    md: 3,
  },
  {
    id: "",
    label: "",
    type: "title",
    md: 3,
  },
  {
    id: "status",
    label: "Status",
    placeHolder: "",
    type: "select",
    options: ["Paid", "Part Paid", "Outstanding", "Pending", "Cancelled"],
    // isRequired: true,
    md: 3,
  },
];

export const Final_Form_Field = [
  {
    id: "insurance_amount",
    label: "Insurance (£)",
    placeHolder: "",
    type: "text",
    // isRequired: true,
    editReadOnly: true,
    md: 2.5,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.PRICE,
  },
  {
    id: "",
    label: "",
    type: "title",
    md: 4,
  },
  {
    id: "deposit_outstanding_balance",
    label: "Deposit Paid (£)",
    placeHolder: "",
    type: "text",
    // isRequired: true,
    editReadOnly: true,
    md: 2.5,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.PRICE,
  },
];
export const PAYMENT_METHOD_OPTIONS = [
  "Debit Card",
  "Credit Card",
  "Cash",
  "Bank Transfer",
  "Direct Debit",
  "Standing Order",
  "Cheque",
  "Contract",
  "Viva Wallet",
  "Other",
];
export const STARTER_INVOICE_VAT_FORM_ELEMENTS = [
  {
    id: "net",
    label: "Net (£)",
    placeHolder: "",
    type: "text",
    isRequired: true,
    // editReadOnly: true,
    md: 3,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.PRICE,
  },
  {
    id: "",
    label: "",
    type: "title",
    md: 6,
  },
  {
    id: "quick_pay",
    label: "Quick Pay (£)",
    placeHolder: "",
    type: "text",
    // isRequired: true,
    editReadOnly: true,
    md: 2,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },

  {
    id: "vat_amount",
    label: "VAT (£)",
    placeHolder: "",
    type: "text",
    // editReadOnly: true,
    // isRequired: true,
    md: 3,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.PRICE,
  },
  {
    id: "is_vat_included",
    label: "\u00A0",
    checkLabel: "VAT Included",
    placeHolder: "",
    type: "checkbox",
    md: 3,
  },
  {
    id: "",
    label: "",
    type: "title",
    md: 3,
  },
  {
    id: "method",
    label: "Method",
    placeHolder: "",
    type: "select",
    options: [],
    // isRequired: true,
    md: 3,
  },
  {
    id: "zero_vat",
    label: "Zero VAT",
    placeHolder: "",
    type: "text",
    editReadOnly: true,
    md: 3,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },

  {
    id: "",
    label: "",
    type: "title",
    md: 6,
  },
  {
    id: "pay_date",
    label: "Pay Date",
    placeHolder: "",
    type: "date",

    md: 3,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "total_amount",
    label: "Total (£)",
    placeHolder: "",
    type: "text",
    editReadOnly: true,
    // isRequired: true,
    md: 3,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "is_values_fixed",
    label: "\u00A0",
    checkLabel: "Fix Values",
    placeHolder: "",
    type: "checkbox",
    md: 3,
  },
  {
    id: "",
    label: "",
    type: "title",
    md: 3,
  },
  {
    id: "status",
    label: "Status",
    placeHolder: "",
    type: "select",
    options: ["Paid", "Part Paid", "Outstanding", "Pending", "Cancelled"],
    // isRequired: true,
    md: 3,
  },
  {
    id: "payment_terms",
    label: "Payment Terms",
    placeHolder: "",
    type: "text",
    md: 12,
  },
];

export const CREDIT_NOTE_INVOICE_VAT_FORM_ELEMENTS = [
  {
    id: "net",
    label: "Net (£)",
    placeHolder: "",
    type: "text",
    isRequired: true,
    // editReadOnly: true,
    md: 3,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.PRICE,
  },
  {
    id: "",
    label: "",
    type: "title",
    md: 6,
  },
  {
    id: "quick_pay",
    label: "Quick Pay (£)",
    placeHolder: "",
    type: "text",
    // isRequired: true,
    editReadOnly: true,
    md: 2,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },

  {
    id: "vat_amount",
    label: "VAT (£)",
    placeHolder: "",
    type: "text",
    // editReadOnly: true,
    // isRequired: true,
    md: 3,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.PRICE,
  },
  {
    id: "is_vat_included",
    label: "\u00A0",
    checkLabel: "VAT Included",
    placeHolder: "",
    type: "checkbox",
    md: 3,
  },
  {
    id: "",
    label: "",
    type: "title",
    md: 3,
  },
  {
    id: "method",
    label: "Method",
    placeHolder: "",
    type: "select",
    options: [],
    // isRequired: true,
    md: 3,
  },
  {
    id: "zero_vat",
    label: "Zero VAT",
    placeHolder: "",
    type: "text",
    editReadOnly: true,
    md: 3,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },

  {
    id: "",
    label: "",
    type: "title",
    md: 6,
  },
  {
    id: "pay_date",
    label: "Pay Date",
    placeHolder: "",
    type: "date",

    md: 3,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "total_amount",
    label: "Grand Total (£)",
    placeHolder: "",
    type: "text",
    editReadOnly: true,
    // isRequired: true,
    md: 3,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  // {
  //   id: "is_values_fixed",
  //   label: "\u00A0",
  //   checkLabel: "Fix Values",
  //   placeHolder: "",
  //   type: "checkbox",
  //   md: 3,
  // },
  {
    id: "",
    label: "",
    type: "title",
    md: 6,
  },
  {
    id: "status",
    label: "Status",
    placeHolder: "",
    type: "select",
    options: ["Paid", "Part Paid", "Outstanding", "Pending", "Cancelled"],
    // isRequired: true,
    md: 3,
  },
  {
    id: "total_amount",
    label: "Refund Amount (£)",
    placeHolder: "",
    type: "text",
    editReadOnly: true,
    // isRequired: true,
    md: 3,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "",
    label: "",
    type: "title",
    md: 9,
  },
  {
    id: "payment_terms",
    label: "Payment Terms",
    placeHolder: "",
    type: "text",
    md: 12,
  },
];

export const quantityFormElements = [
  {
    id: "quantity",
    label: "",
    placeHolder: "",
    type: "text",
    // isRequired: true,
    // md: 2.5,
    inputProps: {
      maxLength: 5,
    },
    patternAllowed: patternConstant?.FLOATNUMERIC,
  },
  {
    id: "description",
    label: "",
    placeHolder: "",
    type: "text",
    // isRequired: true,
    // md: 2.5,
    inputProps: {
      maxLength: 256,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "rate",
    label: "",
    placeHolder: "",
    type: "text",
    // isRequired: true,
    // md: 2.5,
    inputProps: {
      maxLength: 5,
    },
    patternAllowed: patternConstant?.PRICE,
  },
  {
    id: "price",
    label: "",
    placeHolder: "",
    type: "text",
    readonly: true,
    // isRequired: true,
    // md: 2.5,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.PRICE,
  },
  {
    id: "vat_rate",
    label: "",
    placeHolder: "",
    type: "text",
    // readonly: true,
    // isRequired: true,
    // md: 2.5,
    inputProps: {
      maxLength: 3,
    },
    patternAllowed: patternConstant?.FLOATNUMERIC,
  },
  {
    id: "vat_value",
    label: "",
    placeHolder: "",
    type: "text",
    readonly: true,
    // isRequired: true,
    // md: 2.5,
    inputProps: {
      maxLength: 2,
    },
    patternAllowed: patternConstant?.PRICE,
  },
  {
    id: "total",
    label: "",
    placeHolder: "",
    type: "text",
    readonly: true,
    // isRequired: true,
    // md: 2.5,
    inputProps: {
      maxLength: 2,
    },
    patternAllowed: patternConstant?.PRICE,
  },
];

export const paymentFormElements = [
  {
    id: "pay_date",
    label: "",
    placeHolder: "",
    type: "date",
    readonly: true,
    // isRequired: true,
    // md: 2.5,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "payment_method",
    label: "",
    placeHolder: "",
    type: "select",
    options: [],
    readonly: true,
    // isRequired: true,
    // md: 2.5,

    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "payment_type",
    label: "",
    placeHolder: "",
    type: "select",
    options: ["Full", "Deposit", "Part Payment"],
    readonly: true,
    // isRequired: true,
    // md: 2.5,

    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
  {
    id: "amount",
    label: "",
    placeHolder: "",
    type: "text",
    // readonly: true,
    // isRequired: true,
    // md: 2.5,
    inputProps: {
      maxLength: 50,
    },
    patternAllowed: patternConstant?.PRICE,
  },
  {
    id: "note",
    label: "",
    placeHolder: "",
    type: "textarea",
    // readonly: true,
    // isRequired: true,
    // md: 2.5,
    inputProps: {
      maxLength: 250,
    },
    patternAllowed: patternConstant?.ALPHANUMERIC,
  },
];

// Improved validation function
export const invoiceValidateForm = (formData: any) => {
  let isError = false;
  const localError: any = {};

  // Validate services/items in the table
  formData?.items?.forEach((item: any, index: number) => {
    const errors: any = {};

    // Skip validation for empty rows
    if (
      !item?.quantity &&
      !item?.description &&
      !item?.rate &&
      !item?.total &&
      !item?.vat_rate &&
      !item?.vat_value
    ) {
      return; // Skip empty rows
    }

    // Validate quantity
    if (!item?.quantity || item?.quantity <= 0) {
      isError = true;
      errors.quantity = "Please enter a valid quantity";
    }

    // Validate description
    if (!item?.description || item?.description.trim() === "") {
      isError = true;
      errors.description = "Description is required";
    }

  

     // Description
    if (!item?.description || item.description.trim() === "") {
      isError = true;
      errors.description = "Description is required";
    }
    // Validate total (if total should be greater than 0)
    // Validate rate
   if (item?.item_id &&
      item?.description !== "Packing Materials" &&
      item?.description !== "Ancillaries" &&
      item?.description !== "Deposit"
    ) {

        // Validate total (if total should be greater than 0)
    if (!item?.total || item?.total < 0) {
      isError = true;
      errors.total = "Total must be greater than 0";
    }

      if (item?.rate !== null && item?.rate !== undefined && item?.rate < 0) {
        isError = true;
        errors.rate = "Rate cannot be less than 0";
      }
      if (item?.rate === 0) {
        isError = true;
        errors.rate = "Rate must be greater than 0";
      }
   
    }

    // Validate VAT rate (if required, ensure it's a valid percentage)
    if (
      item?.vat_rate === undefined ||
      item?.vat_rate < 0 ||
      item?.vat_rate > 100
    ) {
      isError = true;
      errors.vat_rate = "Please provide a valid VAT rate (0-100)";
    }

    // Validate VAT value (if required, ensure it's consistent with VAT rate)
   if (item?.vat_value < 0 || item?.vat_value === undefined || item?.vat_value === null){
      isError = true;
      errors.vat_value = "Please provide a valid VAT value";
    }

    // If there are any errors for the current item, add them to the localError object
    if (Object.keys(errors).length > 0) {
      if (!localError.items) {
        localError.items = {};
      }
      localError.items[index] = errors;
    }
  });

  // Validate invoice_type of details
  if (!formData?.invoice_type) {
    isError = true;
    localError.invoice_type = "Please select invoice type";
  }

  // Validate date
  // if (!formData?.date) {
  //   isError = true;
  //   localError.date = "Please select invoice date";
  // }

  // Validate net
  if (!formData?.net) {
    isError = true;
    localError.net = "Please enter comments";
  }

  const invoiceDate = formData?.invoice_date || formData?.created_at;
  const dueDate = formData?.due_date;
  if (invoiceDate && dueDate) {
    const invoiceDateOnly = String(invoiceDate).split("T")[0];
    const dueDateOnly = String(dueDate).split("T")[0];
    if (dueDateOnly < invoiceDateOnly) {
      isError = true;
      localError.due_date = "Due date cannot be before the invoice date";
    }
  }

  return { isError, localError };
};

function roundToTwo(num: number) {
  if (num && typeof num === "number") {
    return Math.round(num * 100) / 100;
  } else {
    return 0;
  }
}

// Function to calculate the total based on quantity and rate
export const calculateTotal = (quantity: string, rate: string) => {
  const qty = parseFloat(quantity) || 0;
  const rt = parseFloat(rate) || 0;
  return (qty * rt).toFixed(2);
};

// Function to calculate the VAT value based on total and vatRate
export const calculateVatValue = (total: string, vatRate: string) => {
  const ttl = parseFloat(total) || 0;
  const vatRt = parseFloat(vatRate) || 0;
  return ((ttl * vatRt) / 100).toFixed(2);
};

// Function to calculate the total based on quantity and rate value
export const calculateTotalValue = (price: string, vatValue: string) => {
  const priceVal = parseFloat(price) || 0;
  const vatVal = parseFloat(vatValue) || 0;
  return (priceVal + vatVal).toFixed(2);
};

export const getTotal = (column: any, formData: any) => {
  const formRef = formData;
  let total: number = 0;
  switch (column) {
    case "total":
      formRef?.materials?.forEach((cost: any) => {
        total = roundToTwo(total + Number(cost?.total || 0));
      });
      break;
    case "volume":
      formRef?.materials?.forEach((cost: any) => {
        total = roundToTwo(total + Number(cost?.volume || 0));
      });
      break;
    case "cost":
      formRef?.materials?.forEach((cost: any) => {
        total = roundToTwo(total + Number(cost?.cost || 0));
      });
      break;
    case "ancillaries":
      formRef?.ancillaries?.forEach((cost: any) => {
        total = roundToTwo(total + Number(cost?.charge || 0));
      });
      break;
    case "wages":
      formRef?.services?.forEach((cost: any) => {
        total = roundToTwo(total + Number(cost?.wageCharge || 0));
      });
      break;
    case "costsCost":
      formRef?.services?.forEach((cost: any) => {
        total = roundToTwo(total + Number(cost?.fuelCharge || 0));
      });
      break;
    case "serivesCost":
      formRef?.services?.forEach((service: any) => {
        total = roundToTwo(total + Number(service?.price || 0));
      });
      break;
    default:
      total = 0;
  }
  return total;
};
